import * as z from "zod";
import { isoDate } from "./common";

export const STORE_CUSTOMER_SOURCES = ["LOCAL", "LIGHTSPEED"] as const;
export type StoreCustomerSource = (typeof STORE_CUSTOMER_SOURCES)[number];

/** A shop's own customer, as the counter searches them. Amounts in minor units. */
export const StoreCustomerSummary = z.object({
  id: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  companyName: z.string().nullable(),
  email: z.string().nullable(),
  phone: z.string().nullable(),
  mobile: z.string().nullable(),
  customerCode: z.string().nullable(),
  source: z.enum(STORE_CUSTOMER_SOURCES),
  loyaltyBalanceCents: z.number(),
  enableLoyalty: z.boolean(),
});
export type StoreCustomerSummary = z.output<typeof StoreCustomerSummary>;

export const StoreCustomerSearch = z.object({
  customers: z.array(StoreCustomerSummary),
});

export const STORE_CUSTOMER_HISTORY_SOURCES = ["lightspeed", "hobbyshop"] as const;

export const StoreCustomerHistoryEntry = z.object({
  id: z.string(),
  source: z.enum(STORE_CUSTOMER_HISTORY_SOURCES),
  reference: z.string().nullable(),
  state: z.string(),
  totalCents: z.number(),
  loyaltyCents: z.number().nullable(),
  date: isoDate,
});
export type StoreCustomerHistoryEntry = z.output<typeof StoreCustomerHistoryEntry>;

/** A customer with their purchases, newest first, from Lightspeed and from this app. */
export const StoreCustomerDetail = z.object({
  customer: StoreCustomerSummary,
  history: z.array(StoreCustomerHistoryEntry),
  /** Earned here and not yet credited in Lightspeed. */
  pendingLoyaltyCents: z.number(),
});
export type StoreCustomerDetail = z.output<typeof StoreCustomerDetail>;

/** The customer a cart is now rung up for; null once detached. */
export const CartStoreCustomer = z.object({
  customerCartId: z.string(),
  storeCustomer: StoreCustomerSummary.nullable(),
});
export type CartStoreCustomer = z.output<typeof CartStoreCustomer>;
